// extracted by mini-css-extract-plugin
module.exports = {"deviceDetails":"details_deviceDetails__5_cG5"};